import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useResetRecoilState } from 'recoil';
import { authState } from '../RecoilStore';
import './AppManageLayout.scss';

const NAV_ITEMS = [
  { to: '/appmanage/orders', label: '주문 관리' },
  { to: '/appmanage/menus', label: '메뉴 관리' },
  { to: '/appmanage/operations', label: '운영 관리' },
  { to: '/appmanage/stats', label: '매출 통계' },
];

function AppManageLayout() {
  const navigate = useNavigate();
  const resetAuth = useResetRecoilState(authState);

  const handleLogout = () => {
    resetAuth();
    navigate('/appmanage/login', { replace: true });
  };

  return (
    <div className="AdminLayout">
      <nav className="AdminLayout-sidebar">
        <h1 className="AdminLayout-title">카페앱모아 관리자</h1>
        <ul>
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <button className="AdminLayout-home" onClick={() => navigate('/')}>
          홈
        </button>
        <button className="AdminLayout-logout" onClick={handleLogout}>
          로그아웃
        </button>
      </nav>
      <main className="AdminLayout-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AppManageLayout;
